import { Button, Tooltip } from "antd";

import ReviewStatusTag, { LateArrivingTag, SaeTag } from "./ReviewStatusTag";
import { reviewRowFlag, reviewRowStatus } from "./medicalReview";

export default function ReviewQueueRowActions({
  row,
  marking,
  onMark,
  onReopen,
}: {
  row: Record<string, unknown>;
  marking: boolean;
  onMark: (row: Record<string, unknown>) => void;
  onReopen: (row: Record<string, unknown>) => void;
}) {
  const status = reviewRowStatus(row);
  const isReviewed = status === "reviewed";

  return (
    <div
      className="flex flex-col items-start gap-1"
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      role="presentation"
    >
      <div className="flex flex-wrap items-center gap-1">
        {reviewRowFlag(row, "serious") && <SaeTag />}
        {reviewRowFlag(row, "late_arriving") && <LateArrivingTag />}
        <ReviewStatusTag status={status} />
      </div>
      {isReviewed ? (
        <Tooltip title="Reopen this record for review. It returns to the queue; the original review and the reopening both stay in the history.">
          <Button size="small" loading={marking} onClick={() => onReopen(row)}>
            Reopen
          </Button>
        </Tooltip>
      ) : (
        <Button size="small" loading={marking} onClick={() => onMark(row)}>
          Mark reviewed
        </Button>
      )}
    </div>
  );
}
